module.exports = __webpack_public_path__ + "img/discount.86e797b8.svg";